import { render, staticRenderFns } from "./icare_detail_youth.vue?vue&type=template&id=0d5dff62&"
import script from "./icare_detail_youth.vue?vue&type=script&lang=js&"
export * from "./icare_detail_youth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports